import React from 'react';
import './App.css';
import ReactDOM from 'react-dom';

const siteTitle = "PATH PAINT";
const siteTagline = "Path Paint";


let contentArray = [  
  {slideContent: "images/teal-grouping-yin-yang.png",
  title: "teal-grouping-yin-yang.png",
  year: 2021,
  imageDimensions: "1490px x 973px"
  },
  {slideContent: "images/assorted-yin-yangs.png",
  title: "assorted-yin-yangs.png",
  year: 2021,
  imageDimensions: "1574px x 961px"
  },
  {slideContent: "images/an-arrangement-of-yin-yangs.png",
  title: "an-arrangement-of-yin-yangs.png",
  year: 2021,
  imageDimensions: "1441px x 975px"
  },
  {slideContent: "images/yin-yangs-and-teal-composition.png",
  title: "yin-yangs-and-teal-composition.png",
  year: 2021,
  imageDimensions: "1379px x 973px"
  },
  {slideContent: "images/pattern-of-yin-yangs.png",
  title: "pattern-of-yin-yangs.png",
  year: 2021,
  imageDimensions: "1914px x 973px"
  },
  {slideContent: "images/groupings-of-yin-yangs.png",
  title: "groupings-of-yin-yangs.png",
  year: 2021,
  imageDimensions: "1660px x 975px"
  },
  {slideContent: "images/yin-yangs-with-teal.png",
  title: "yin-yangs-with-teal.png",
  year: 2021,
  imageDimensions: "1544px x 971px"
  },
  {slideContent: "images/yin-and-yang.png",
  title: "yin-and-yang.png",
  year: 2021,
  imageDimensions: "1435px x 975px"
  },
  {slideContent: "images/yin-yangs-revisited.png",
  title: "yin-yangs-revisited.png",
  year: 2021,
  imageDimensions: "1541px x 903px"
  },
  {slideContent: "images/yin-yangs-and-dots.png",
  title: "yin-yangs-and-dots.png",
  year: 2021,
  imageDimensions: "1494px x 974px"
  },
  {slideContent: "images/yin-yangs-and-teal-revisited.png",
  title: "yin-yangs-and-teal-revisited.png",
  year: 2021,
  imageDimensions: "1457px x 940px"
  },
  {slideContent: "images/summer-flowers.png",
  title: "summer-flowers.png",
  year: 2021,
  imageDimensions: "1654px x 974px"
  },
  {slideContent: "images/fish-swimming.png",
  title: "fish-swimming.png",
  year: 2017,
  imageDimensions: "1080px x 798px"
  },
  {slideContent: "images/download-15-web.png",
  title: "download-15-web.png",
  year: 2018,
  imageDimensions: "774px x 1034px (web)"
  },
  {slideContent: "images/untitled-landscape_012345.png",
  title: "untitled-landscape_012345.png",
  year: 2018,
  imageDimensions: "777px x 1033px (web)"
  },
  {slideContent: "images/=).png",
  title: "=).png",
  year: 2021,
  imageDimensions: "1642px x 972px"
  },
  {slideContent: "images/snail-and-saxophone.png",
  title: "snail-and-saxophone.png",
  year: 2020,
  imageDimensions: "1250px x 953px"
  },
  {slideContent: "images/yin-yangs-4.png",
  title: "yin-yangs-4.png",
  year: 2021,
  imageDimensions: "1341px x 974px"
  },
  {slideContent: "images/yin-yangs-3.png",
  title: "yin-yangs-3.png",
  year: 2021,
  imageDimensions: "1505px x 973px"
  },
  {slideContent: "images/download3-for-web.png",
  title: "download3-for-web.png",
  year: 2020,
  imageDimensions: "3600px x 4800px"
  },
  {slideContent: "images/glyphs.png",
  title: "glyphs.png",
  year: 2019,
  imageDimensions: "3600px x 4800px"
  },
  {slideContent: "images/download-14.png",
  title: "download-14.png",
  year: 2017,
  imageDimensions: "3600px x 4800px"
  },
  {slideContent: "images/trails.png",
  title: "trails.png",
  year: 2020,
  imageDimensions: "1434px x 945px"
  },
  {slideContent: "images/download-13.png",
  title: "download-13.png",
  year: 2017,
  imageDimensions: "3600px x 4800px"
  },
  {slideContent: "images/download-10.png",
  title: "download-10.png",
  year: 2017,
  imageDimensions: "3600px x 4800px"
  },
  {slideContent: "images/download-2_web_768x1024.png",
    title: "download-2_web_768x1024.png",
    year: 2017,
    imageDimensions: "3600px x 4800px"
    },
    {slideContent: "images/flowers-with-yin-yangs.png",
    title: "flowers-with-yin-yangs.png",
    year: 2021,
    imageDimensions: "1455px x 963px"
    },
    {slideContent: "images/yin-yangs-and-teal_2.png",
    title: "yin-yangs-and-teal_2.png",
    year: 2021,
    imageDimensions: "1428px x 971px"
    },
    {slideContent: "images/blue-lines.png",
    title: "blue-lines.png",
    year: 2019,
    imageDimensions: "1645px x 927px"
    },
    {slideContent: "images/communication.png",
    title: "communication.png",
    year: 2019,
    imageDimensions: "1413px x 884px"
    },
    {slideContent: "images/untitled_2021.png",
    title: "untitled_2021.png",
    year: 2021,
    imageDimensions: "1427px x 974px"
    },
    {slideContent: "images/yin-yangs-and-teal.png",
    title: "yin-yangs-and-teal.png",
    year: 2021,
    imageDimensions: "1477px x 974px"
    },
    {slideContent: "images/butterflies3.png",
    title: "butterflies3.png",
    year: 2020,
    imageDimensions: "1433px x 947px"
    },
    {slideContent: "images/untitled_landscape.png",
    title: "untitled_landscape.png",
    year: 2018,
    imageDimensions: "1609px x 974px"
    },
    {slideContent: "images/untitled_landscape_001.png",
    title: "untitled_landscape_001.png",
    year: 2017,
    imageDimensions: "924px x 787px"
    },
    {slideContent: "images/slopes.png",
    title: "slopes.png",
    year: 2017,
    imageDimensions: "1164px x 1023px"
    },
    {slideContent: "images/debug.png",
    title: "debug.png",
    year: 2019,
    imageDimensions: "1231px x 923px"
    },
    {slideContent: "images/untitled_composition.png",
    title: "untitled_composition.png",
    year: 2019,
    imageDimensions: "1377px x 922px"
    },
    {slideContent: "images/yinyangs2.png",
    title: "yinyangs2.png",
    year: 2020,
    imageDimensions: "1794px x 966px"
    },
    {slideContent: "images/yinyangs.png",
    title: "yinyangs.png",
    year: 2020,
    imageDimensions: "1613px x 941px"
    },
    {slideContent: "images/untitled_painting_012345.png",
    title: "untitled_painting_012345.png",
    year: 2017,
    imageDimensions: "1585px x 944px"
    },
    {slideContent: "images/time.png",
    title: "time.png",
    year: 2018,
    imageDimensions: "1916px x 977px"
    },
    {slideContent: "images/sight.png",
    title: "sight.png",
    year: 2020,
    imageDimensions: "1587px x 974px"
    },
    {slideContent: "images/puppies-and-pines.png",
    title: "puppies-and-pines.png",
    year: 2017,
    imageDimensions: "1079px x 801px"
    },
    {slideContent: "images/untitled_yellow-and-blue.png",
    title: "untitled_yellow-and-blue.png",
    year: 2019,
    imageDimensions: "1660px x 919px"
    },
    {slideContent: "images/untitled_path-painting.png",
    title: "untitled_path-painting.png",
    year: 2019,
    imageDimensions: "1699px x 919px"
    },
    {slideContent: "images/pine-tree-landscape.png",
    title: "pine-tree-landscape.png",
    year: 2017,
    imageDimensions: "1075px x 798px"
    },
    {slideContent: "images/puppies.png",
    title: "puppies.png",
    year: 2017,
    imageDimensions: "1078px x 795px"
    },
    {slideContent: "images/untitled.png",
    title: "untitled.png",
    year: 2020,
    imageDimensions: "1166px x 966px"
    },
    {slideContent: "images/digital-harmony.png",
    title: "digital-harmony.png",
    year: 2018,
    imageDimensions: "1423px x 898px"
    },
    {slideContent: "images/landscape.png",
    title: "landscape.png",
    year: 2017,
    imageDimensions: "1180px x 792px"
    },
    {slideContent: "images/untitled_painting.png",
    title: "untitled_painting.png",
    year: 2017,
    imageDimensions: "1075px x 792px"
    },
    {slideContent: "images/pathpaint.png",
    title: "pathpaint.png",
    year: 2020,
    imageDimensions: "1456px x 926px"
    },
    {slideContent: "images/flowers.png",
    title: "flowers.png",
    year: 2020,
    imageDimensions: "1356px x 966px"
    },
    {slideContent: "images/cernen.png",
    title: "cernen.png",
    year: 2019,
    imageDimensions: "1601px x 929px"
    },
    {slideContent: "images/2019-11-07.png",
    title: "2019-11-07.png",
    year: 2019,
    imageDimensions: "1488px x 916px"
    },
    {slideContent: "images/untitled2495872349671.png",
    title: "untitled2495872349671.png",
    year: 2020,
    imageDimensions: "1384px x 954px"
    },
    {slideContent: "images/extra-love.png",
    title: "extra-love.png",
    year: 2020,
    imageDimensions: "1282px x 974px"
    },
    {slideContent: "images/clouds1.png",
    title: "clouds1.png",
    year: 2020,
    imageDimensions: "730px x 476px"
    },
    {slideContent: "images/butterflies-and-dolphins.png",
    title: "butterflies-and-dolphins.png",
    year: 2020,
    imageDimensions: "1253px x 943px"
    }
];

class ContentModule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0
    };
  }

  changeSlide = () => {
    let activeIndex = this.state.activeIndex;
    if (activeIndex === this.props.contentArray.length -1) {
      activeIndex = 0;
    } else {
      activeIndex++;
    }
    this.setState({
      activeIndex
    });
  }

  render() {
    return(
      <main className="main-container" role="main">

      <nav className="navigation-container" role="navigation">
        <div className="nav-inner-wrapper">
          <div className="navigation-child">
            <a href="/" alt={siteTitle} title={siteTitle}>
              <h1 title={siteTitle} alt={siteTitle} className="site-title-class">{siteTitle}</h1>
            </a>
          </div>
          <div className="navigation-child">
            <button className ="button-class" onClick={this.changeSlide} title="Change Image" alt="Click to change image">
            Change Content
            </button>
          </div>
        </div>
        </nav>

       <div className="flex-slider-container">

         <div className="flex-slider-content">
            <img src={this.props.contentArray[this.state.activeIndex].slideContent} alt={this.props.contentArray[this.state.activeIndex].title} title={this.props.contentArray[this.state.activeIndex].title} id="imageID" className="img-responsive" />
         </div>

       </div>

       <div className="painting-details">
          <span className="painting-details-class">{this.props.contentArray[this.state.activeIndex].title}<br /> {this.props.contentArray[this.state.activeIndex].year}, {this.props.contentArray[this.state.activeIndex].imageDimensions}<br />
          <a href={`images/${this.props.contentArray[this.state.activeIndex].title}`} target="_blank" rel="noopener noreferrer">Enlarge</a> </span>
       </div>

       <a className="weekly-button-container" href="https://andrewrosinski.com" target="_blank" title="Andrew Rosinski" rel="noopener noreferrer">
         <span className="weekly-button-text-class" alt={siteTagline} title={siteTagline}>{siteTagline}</span>
       </a>

     </main>

    );
  }
}

ReactDOM.render(
  <ContentModule contentArray = {contentArray} />,
  document.getElementById('sectionOne')
);

class App extends React.Component {

  render() {
    return(
        <div id="sectionOne"></div>
    );
  }
}

export default App;